import React from "react";
import "./LearnMoreSectionThree.css";
import ReactHtmlParser from "react-html-parser";

export default function LearnMoreSectionThree(props) {
  return (
    <>
      <div className="selectionSecuritycontainer">
        <p className="selectionSecuritytitleTxt">{props.title}</p>
        {ReactHtmlParser(props.data)}
      </div>
    </>
  );
}
